import { HttpClient } from '#client/http/index'
import {
  ListPrefecturesResponse,
  PrefectureId,
  prefectures,
} from '#client/resources/index'

export const list = async ({ httpClient }: { httpClient: HttpClient }) => {
  const data: ListPrefecturesResponse = await httpClient.get(
    `/user/prefectures`,
  )
  return data
}

export const getSync = (_deps: Record<string, unknown>, id: PrefectureId) =>
  prefectures.find(({ id: prefId }) => prefId === id)

export const get = (_deps: Record<string, unknown>, id: PrefectureId) =>
  Promise.resolve(getSync(_deps, id))
